import { useLocation } from 'react-router-dom';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useHubEnabled } from '../../hooks/hub/useHub';
import { isV2PreviewEnabled } from '../../utils/featureFlags';
import { useShellView } from './shellView';

/** True when the user may see the v2 shell at all (and so the portal toggle). */
export function useV2Preview(): boolean {
  const { user } = useCurrentUser();
  return isV2PreviewEnabled(user ?? null);
}

/**
 * True when the frame shows the v2 shell (mock sidebar + top bar): the user
 * passes `isV2PreviewEnabled` AND has not switched to the classic portal.
 * v1 users never see it. The Hub workspace keeps its own sidebar.
 */
export function useV2Shell(): boolean {
  const preview = useV2Preview();
  const view = useShellView();
  const hubEnabled = useHubEnabled();
  const { pathname } = useLocation();
  return preview && view === 'v2' && !(hubEnabled && pathname.startsWith('/hub'));
}
